module.exports = __webpack_public_path__ + "static/media/img27.58aa833d.JPG";